import { useState } from 'react';
import { checkFieldValue } from '../constants/fieldValidators';
import { useDictionaryTranslation } from '../../../hooks/useDictionaryTranslation';
import { getContainerTitle } from '../constants/mobileFormConstants';

export const useFormErrors = () => {
  const { translate: t } = useDictionaryTranslation();
  const [formErrors, setFormErrors] = useState(null);

  const checkFields = (fields = [], values) => {
    const errors = [];
    for (const field of fields) {
      const error = checkFieldValue(field, values?.[field.idInput]);
      if (error != null) {
        errors.push({
          idInput: field.idInput,
          label: field.label,
          error,
        });
      }
    }
    return errors;
  };

  const checkFormErrors = (baseStructure, values) => {
    const newFormErrors = [];
    if (baseStructure == null) return newFormErrors;
    for (let i = 0; i < baseStructure.length; i += 1) {
      const page = baseStructure[i];
      const errors = checkFields(page.list, values);
      newFormErrors.push({
        id: i,
        title: getContainerTitle(page.label, i, t),
        errors,
      });
    }
    setFormErrors(newFormErrors);
    return newFormErrors;
  };

  return { formErrors, checkFormErrors };
};
